module.exports = __webpack_public_path__ + "img/gequ.759c7a84.png";